// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import ResultsModal from './ResultsModal';
import { getApiEndpoint } from '../../config/newgenome-config';

const Home = () => {
  /* ───────────────────────────────────
     Knowledge‑base counts (static demo)
  ─────────────────────────────────── */
  const [dbStats] = useState({
    evidence: 11148,
    molecularprofiles: 4016,
    variants: 3890,
    therapies: 578,
    diseases: 435,
    assertions: 169
  });

  /* ───────────────────────────────────
     Uploads (replaces Quick‑Actions)
  ─────────────────────────────────── */
  const [uploads, setUploads] = useState([]);
  const [savedUploads, setSavedUploads] = useState([]);
  const [selectedUpload, setSelectedUpload] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Get cookie from document.cookie
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    };

    const fetchSavedUploads = async () => {
      try {
        // Get account_id from cookie or use fallback
        let account_id = getCookie('account_id');
        if (!account_id) {
          account_id = '80uo2j7e'; // Fallback for demo
          console.log('Using fallback account ID for demo');
        }

        const response = await fetch(`${getApiEndpoint('uploads')}?account_id=${account_id}`);
        if (!response.ok) throw new Error('Failed to fetch uploads');
        
        const data = await response.json();
        setSavedUploads(data);
        console.log(data);
      } catch (error) {
        console.error('Error fetching saved uploads:', error);
      }
    };

    fetchSavedUploads();
  }, []);
  
  const openResultsModal = (upload) => {
    setSelectedUpload(upload);
    setIsModalOpen(true);
  };

  // Helper function to determine file type icon and class
  const getFileTypeInfo = (item) => {
    const filename = item.original_files?.toLowerCase() || '';
    
    if (filename.includes('vcf') || filename.includes('.vcf.gz')) {
      return { icon: 'fa-file-medical-alt', cssClass: 'vcf', label: 'VCF File' };
    } else if (filename.includes('chr') && 
             (filename.includes('_del') || 
              filename.includes('_dup') || 
              filename.match(/\d+_[atcg]_[atcg]/i))) {
      return { icon: 'fa-dna', cssClass: 'variant', label: 'Variant' };
    } else if (filename.match(/^[a-z0-9]+$/i) || filename.includes('gene')) {
      return { icon: 'fa-dna', cssClass: 'gene', label: 'Gene' };
    } else {
      return { icon: 'fa-file-alt', cssClass: '', label: 'Analysis' };
    }
  };
  
  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  /* ───────────────────────────────────
     Search + filters
  ─────────────────────────────────── */
  const [searchQuery, setSearchQuery]   = useState('');
  const [extraFilters, setExtraFilters] = useState('');
  const fileInput = useRef(null);

  const handleFiles = files => {
    const list = [...uploads, ...Array.from(files)];
    setUploads(list);
  };

  const onDrop = e => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const runAnalysis = () => {
    // stub – integrate with backend
    console.log({ searchQuery, extraFilters, uploads });
  };

  /* ───────────────────────────────────
     Rotating header messages
  ─────────────────────────────────── */
  const messages = [
    'Accelerating precision oncology insights',
    'Seamless knowledge for clinicians',
    'Welcome back, stay curious'
  ];
  const [currentMessage, setCurrentMessage] = useState(0);
  useEffect(() => {
    const id = setInterval(
      () => setCurrentMessage(i => (i + 1) % messages.length),
      4000
    );
    return () => clearInterval(id);
  }, []);

  /* ───────────────────────────────────
     Latest updates (static demo)
  ─────────────────────────────────── */
  const latestUpdates = [
    { id: 1, type: 'database',    component: 'Variant Database',  date: '2025‑05‑28', description: 'Added 143 new pathogenic variants' },
    { id: 2, type: 'feature',     component: 'Pipeline Analysis', date: '2025‑05‑25', description: 'Enhanced report generation with multi‑sample comparison' },
    { id: 3, type: 'integration', component: 'API Services',      date: '2025‑05‑20', description: 'New integrations with clinical decision support systems' },
    { id: 4, type: 'update',      component: 'Knowledge Base',    date: '2025‑05‑15', description: 'Updated therapeutic recommendations based on latest guidelines' }
  ];

  return (
    <div className="WSNG-home" onDragOver={e => e.preventDefault()} onDrop={onDrop}>
      {/* ─────────── header ─────────── */}
      <header className="WSNG-home-header">
        <div className="WSNG-welcome-container">
          <h1>Welcome to NewGenome</h1>
          <p>Advanced genomic analysis and knowledge platform</p>
        </div>
     
      </header>

      {/* ─────────── content grid ─────────── */}
      <main className="WSNG-home-content">
        {/* ───── left column ───── */}
        <section className="WSNG-left-column">
          {/* knowledge overview (now with search / drop / filters / run) */}
          <div className="WSNG-section-less WSNG-kb-stats-section">
          <h2><i className="fas fa-history"></i>Search Variant/Gene</h2>
          <input
              className="WSNG-search-bar"
              type="text"
              placeholder="Input Variant/Gene..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />

            {/* file‑drop */}
            <div
              className="WSNG-filedrop"
              onClick={() => fileInput.current?.click()}
            >
              <p>{uploads.length ? 'Add more VCF files' : 'Drop VCF file(s) here or click to browse'}</p>
              <input
                ref={fileInput}
                type="file"
                accept=".vcf"
                multiple
                onChange={e => handleFiles(e.target.files)}
              />
            </div>

<div className="WSNG-run-btns"> 
            <button className="WSNG-run-btn" onClick={runAnalysis}>
              <i className="fas fa-play"></i> <div> RUN </div>
            </button>
            <button className="WSNG-filter-btn" onClick={runAnalysis}>
              <i className="fas fa-filter"></i> <div> FILTER </div>
            </button>
            </div>


          </div>

          {/* uploads list */}
          <div className="WSNG-section WSNG-uploads-section">
            <h2><i className="fas fa-upload"></i>Uploads</h2>

            <div className="WSNG-saved-uploads">
              {savedUploads.length === 0 ? (
                <p className="WSNG-empty-note">No saved analysis results found.</p>
              ) : (
                <div className="WSNG-upload-list WSNG-saved-list">
                  {savedUploads.map((item, idx) => {
                    const typeInfo = getFileTypeInfo(item);
                    return (
                      <div 
                        key={idx} 
                        className={`WSNG-upload-item WSNG-saved-item ${typeInfo.cssClass}`}
                        onClick={() => openResultsModal(item)}
                      >
          
                        
                        <div className="WSNG-saved-item-header">
                          <div className="WSNG-saved-item-main">
                            <div className="WSNG-saved-item-icon">
                              <i className={`fas ${typeInfo.icon}`}></i>
                            </div>
                            <div className="WSNG-saved-item-content">
                              <div className="WSNG-saved-item-title-container">
                                <div className="WSNG-saved-item-title" title={item.original_files}>
                                  {item.original_files || item.uuid}
                                </div>
                                {item.notes && (
                                  <div className="WSNG-saved-item-notes">
                                    {item.notes}
                                  </div>
                                )}
                              </div>
                              <div className="WSNG-saved-item-uuid">
                                {item.uuid}
                              </div>
                              <div className="WSNG-saved-item-files">
                                {item.files.length} {item.files.length === 1 ? 'file' : 'files'}
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div className="WSNG-saved-item-details">
                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Uploaded</div>
                            <div className="WSNG-saved-item-detail-value">
                              {formatDate(item.upload_time)}
                            </div>
                          </div>
                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Processing Started</div>
                            <div className="WSNG-saved-item-detail-value">
                              {formatDate(item.pipeline_initiated_time)}
                            </div>
                          </div>
                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Completed</div>
                            <div className="WSNG-saved-item-detail-value">
                              {formatDate(item.pipelines_completed_time)}
                            </div>
                          </div>
                          <div className="WSNG-saved-item-detail">
                            <div className="WSNG-saved-item-detail-label">Status</div>
                            <div className="WSNG-saved-item-detail-value">
                              <span className={`WSNG-saved-item-status ${item.status?.toLowerCase() || 'completed'}`}>
                                <i className="fas fa-check-circle"></i>
                                {item.status || 'Completed'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* ───── right column ───── */}
        <aside className="WSNG-right-column">
          <div className="WSNG-section WSNG-updates-section">
            <h2><i className="fas fa-history"></i>Latest Updates</h2>
            <div className="WSNG-updates-list">
              {latestUpdates.map(u => (
                <div key={u.id} className="WSNG-update-item">
                  <div className="WSNG-update-icon">
                    <i className={`fas fa-${
                      u.type === 'database'    ? 'database' :
                      u.type === 'feature'     ? 'star'     :
                      u.type === 'integration' ? 'plug'     : 'sync'
                    }`}/>
                  </div>
                  <div className="WSNG-update-content">
                    <div className="WSNG-update-header">
                      <h4>{u.component}</h4>
                      <span className="WSNG-update-date">{u.date}</span>
                    </div>
                    <p>{u.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* resources */}
            <div className="WSNG-resources-container">
              <h2><i className="fas fa-tools"></i>Additional Resources</h2>
              <div className="WSNG-resources-grid">
                <Resource
                  icon="cogs"
                  title="Settings"
                  text="Configure application preferences, API connections, and user access"
                  btn="Open Settings"
                />
                <Resource
                  icon="question-circle"
                  title="Help & Support"
                  text="Access documentation, tutorials, and contact technical support"
                  btn="View Help"
                />
              </div>
            </div>
          </div>
        </aside>
      </main>
      
      {/* Results modal */}
      <ResultsModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        data={selectedUpload}
      />
    </div>
  );
};

const Resource = ({ icon, title, text, btn }) => (
  <div className="WSNG-resource-card">
    <div className="WSNG-resource-icon"><i className={`fas fa-${icon}`}/></div>
    <div className="WSNG-resource-content">
      <h3>{title}</h3><p>{text}</p>
      <button className="WSNG-resource-button"><i className="fas fa-arrow-right" />{btn}</button>
    </div>
  </div>
);

export default Home;
